import { BatchesService } from '@festina/datamart2-general-types/datamart2/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitDatamart2Batch = () =>
  useFestinaMutation({
    component: 'dataMart2',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
